import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateSEO } from '../utils/seoUtils';

export function useDynamicBranding() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const isRocha = path.startsWith('/parceiros/rocha');
    const isProduct = /^\/parceiros\/rocha\/produto\//.test(path);

    // Favicon
    const favicon = document.getElementById('favicon');
    if (favicon) {
      favicon.href = isRocha ? '/rocha_yinyang.png' : '/aug_logo.png';
    }

    // SEO — só para rotas que não têm SEO próprio (produto tem SEO próprio na página)
    if (isRocha && !isProduct) {
      updateSEO({
        title: 'Rocha Climatização | Peças de Ar Condicionado em Palmas-TO',
        description: 'Compressores, tubos de cobre, gás refrigerante e peças para ar condicionado em Palmas-TO. Frete para todo o Brasil. Parcele em até 10x.',
        ogImage: '/rocha_yinyang.png',
        ogUrl: '/parceiros/rocha',
        ogType: 'website',
      });
    } else if (!isRocha) {
      updateSEO({
        title: 'Agro Urban Global | Soluções Inteligentes para seu Negócio',
        description: 'Plataforma de soluções para negócios: CRM, inteligência artificial, marketplace e muito mais.',
        ogImage: '/aug_logo.png',
        ogUrl: '/',
        ogType: 'website',
      });
    }
  }, [location.pathname]);
}
